import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { setUserData, logoutUser } from '../redux/actions/UserActions';
import { setDefaultTrxAct } from '../redux/actions/LocationActions';
import jwtAuthService from '../services/jwtAuthService';
import localStorageService from '../services/localStorageService';
import IdleTimer from 'react-idle-timer';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

class Auth extends Component {
  state = {
    dialog: false,
    secondsElapsed: 30,
    storedTime: 0
  };

  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.handleOnActive = this.handleOnActive.bind(this);
    this.handleOnAction = this.handleOnAction.bind(this);
    const user = localStorageService.getItem('auth_user');
    this.props.setUserData(user);

    if (user) {
      this.checkJwtAuth(user);
    }
  }

  checkJwtAuth = async user => {
    const newUser = await jwtAuthService.loginWithToken(user);
    this.props.setUserData(newUser);
  };

  render() {
    const { children } = this.props;
    return (
      <Fragment>
        {children}
        {localStorage.jwt_token !== undefined ? (
          <div>
            <Dialog onClick={() => {}} disableEscapeKeyDown maxWidth='xs' aria-labelledby='confirmation-dialog-title' open={this.state.dialog}>
              <DialogTitle id='confirmation-dialog-title'>Warning!</DialogTitle>
              <DialogContent>
                Your session is about to expire due to inactivity.
                <p>
                  Remaining <b>{this.state.secondsElapsed}</b> seconds to logout
                </p>
              </DialogContent>
              <DialogActions style={{ paddingBottom: '13px', paddingRight: '15px' }}>
                <Button className='capitalize' autoFocus variant='contained' color='primary' onClick={this.sessionContinue}>
                  Continue Session
                </Button>
                <Button variant='contained' color='secondary' onClick={this.isLogout}>
                  Log Out
                </Button>
              </DialogActions>
            </Dialog>
            <IdleTimer
              ref={ref => {
                this.idleTimer = ref;
              }}
              StartOnMount={this.handleAutoLogout}
              onActive={this.handleOnActive}
              onAction={this.handleOnAction}
            ></IdleTimer>
          </div>
        ) : (
          ''
        )}
      </Fragment>
    );
  }

  handleAutoLogout = () => {
    console.log('handleAutoLogout');
    this.handleLogout(true);
  };

  sessionContinue = () => {
    this.resetTime();
    this.idleTimer.reset();
    const { detect } = require('detect-browser');
    const browser = detect();
    if (browser.name === 'safari') {
      this.setState({ dialog: false, storedTime: 0 });
    }
  };

  handleOnActive(event) {}

  handleOnAction(event) {
    var compareMinute = 870 * 1000;
    var time = new Date().getTime();
    if (sessionStorage.resetSessionTimer === 'YES') {
      sessionStorage.resetSessionTimer = 'NO';
      this.setState({ dialog: false, storedTime: 0 });
    }

    if (this.state.storedTime > 0) {
      var differenceBetween = time - this.state.storedTime;

      if (differenceBetween > compareMinute && this.state.dialog === false) {
        let sleeptime = differenceBetween - compareMinute;
        if (sleeptime > 30000) {
          this.handleLogout(true);
        } else {
          this.setState({ dialog: true, storedTime: time });
          this.startTime();
        }
      } else {
        this.setState({ storedTime: time });
      }
    } else {
      this.setState({ storedTime: time });
    }
  }

  handleLogout = bShowTimeOutError => {
    this.resetTime();
    sessionStorage.userSessionOut = bShowTimeOutError;
    this.props.logoutUser();
  };

  isLogout = () => {
    this.handleLogout(false);
  };

  startTime = () => {
    var _this = this;
    this.countdown = setInterval(this.count, 1000, _this);
  };

  count = _this => {
    _this.setState({ secondsElapsed: _this.state.secondsElapsed - 1 });
    if (this.state.secondsElapsed <= 0) {
      this.handleLogout(true);
    }
  };

  resetTime = () => {
    clearInterval(this.countdown);
    this.reset = this.setState({
      dialog: false,
      secondsElapsed: 30,
      storedTime: new Date().getTime()
    });
  };
}

const mapStateToProps = state => ({
  setUserData: PropTypes.func.isRequired,
  login: state.login,
  logoutUser: PropTypes.func.isRequired
});

window.onload = function () {
  window.sessionStorage.userSessionOut = false;
  window.sessionStorage.resetSessionTimer = 'YES';
};

export default connect(mapStateToProps, {
  setUserData,
  logoutUser,
  setDefaultTrxAct
})(Auth);
